import { TextBox } from '@apply/components';
import { useBorrowerThirdPartyName } from '../../../../../queries/BorrowerFields/ThirdPartyFields';

export const FinalizeThirdPartyName: React.FC = () => {
    const [finalizeThirdPartyName, set_finalizeThirdPartyName] = useBorrowerThirdPartyName();
    return (
        <TextBox
            value={finalizeThirdPartyName ?? ''}
            onChange={(value) => set_finalizeThirdPartyName(value)}
            label='Party Name'
            required={true}
        />
    );
};
